import axios, { AxiosInstance } from "axios";

export interface IExternalHttpClient extends AxiosInstance {
}

export default class ExternalHttpClient {
    
    static getClient(authenticationKey: string): IExternalHttpClient {
        return this.getClientInternal(authenticationKey, process.env.REACT_APP_PROXY_API_BASE_URL);
    }

    private static getClientInternal(authenticationKey: string, baseUrl: string): IExternalHttpClient {
        const defaultHeaders = {
            Authorization: `key ${authenticationKey}`
        };

        var client = axios.create({
            baseURL: baseUrl,
            headers: defaultHeaders
        });

        const httpClient = new ExternalHttpClient();
        return {...client, ...httpClient } as IExternalHttpClient;
    }
}